import { render, staticRenderFns } from "./Lf.vue?vue&type=template&id=b3d1deb0&scoped=true&"
import script from "./Lf.vue?vue&type=script&lang=js&"
export * from "./Lf.vue?vue&type=script&lang=js&"
import style0 from "./Lf.vue?vue&type=style&index=0&id=b3d1deb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d1deb0",
  null
  
)

export default component.exports